export const formatName = (prefix?: string, name?: string): string =>
  prefix ? `${prefix}.${name}` : name || '';
